export const minutesToHourTime = (minutes) => {
  const zeroLeft = (n) => Math.floor(n).toString().padStart(2, '0')
  const hour = zeroLeft(minutes / 60)
  const min = zeroLeft(minutes % 60)
  return `${hour}:${min}`
}
